import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function Home() {
  return (
    <div className="main-content">
      <div className="image-container">
        <img
          className="image"
          src="./images/web_home.jpg"
          alt="web_home"
        />
      </div>

      <div className="logo-container">
        <div className="logo-symbol">
          <img
            src="./images/logo_original.png"
            alt="logo"
          />
        </div>
      </div>

      <div className="text-container">
        <span className="text-bold">뻔(FFUN)</span>
        <span className="text-contents">은 반려생활의 다양성을 포용하고<br />편견을 배제한 2재미(FFUN)로 채우는<br /></span>
        <span className="text-bold">반려인의 가치</span>
        <span>를 상징합니다.</span>
      </div>

      <div className="contact-button-container">
        <Link to="/contact" className="contact-button">
          문의하기
        </Link>
      </div>
    </div>
  );
}

export default Home; 